import Router from './Router.vue'
import Vue from 'vue'

const MergeRecursive = (obj1, obj2) => {
  for (var p in obj2) {
    try {
      // Property in destination object set; update its value.
      if (obj2[p].constructor == Object) {
        obj1[p] = MergeRecursive(obj1[p], obj2[p])
      } else {
        obj1[p] = obj2[p]
      }
    } catch(e) {
      // Property in destination object not set; create it and set its value.
      obj1[p] = obj2[p]
    }
  }

  return obj1
}

const defaultConfig = {
  'permissionSection': {
    'permissions': [],
    'newsletters': [],
    'inputError': {
      'valueMissing': 'Kryds venligst dette felt af for at fortsætte',
    }
  },
  'emailInput': {
    'label': 'Email',
    'inputError': {
      'valueMissing': 'Udfyld venligst feltet',
      'typeMismatch': 'Indtast venligst en gyldig e-mail'
    }
  },
  'submitButton': {
    'label': 'Tilmeld'
  },
  'loadingIndicator': {
    'html': '<p>Loading...</p>'
  },
  'response': {
    'success': 'Tak for din tilmelding',
    'error': 'Der er desværre sket en fejl, prøv igen senere'
  },
  'callback': {}
}

module.exports =
  class Form {
    constructor (userConfig) {
      const config = MergeRecursive(defaultConfig, userConfig)
      const Root = Vue.extend({
        template: '<router></router>',
        components: [Router],
        data() {
          return {
            config: config
          }
        }
      })

      this.el = new Root()
    }

    render (mount) {
      this.el.$mount().$appendTo(mount, this.el.config.callback.onRender)
    }

    destroy () {
      this.el.$destroy(true)
    }
}



// WEBPACK FOOTER //
// ./src/form.js